// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CEjhSnb7IOaNG5 {
  display: flex;
  position: relative;
  z-index: 10;
  flex-direction: row;
  align-items: center;
  width: calc(100% - 8px * 2);
  height: 8px;
  padding: var(--ds-space-0, 0) 8px;
  transition: opacity;
  opacity: 0;
  cursor: pointer;
  will-change: clip-path;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  gap: 3px;
}
.CEjhSnb7IOaNG5.xrpDw8bh5z3DDg {
  pointer-events: none;
}
.CEjhSnb7IOaNG5:hover {
  transition-delay: 0.15s;
  opacity: 1;
}
.CEjhSnb7IOaNG5 .YGGQRDU5eWkKri {
  flex: 50%;
  width: 100%;
  height: 0;
  border-top: 2px dashed var(--ds-background-accent-gray-subtle-hovered, #b3b9c4);
}
.CEjhSnb7IOaNG5 .gGeIJ78ljfGpfn {
  position: relative;
  flex: 0 0 auto;
  width: 22px;
  height: 18px;
  border-radius: var(--ds-border-radius-100, 4px);
  background-color: var(--ds-surface, #ffffff);
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
}
.CEjhSnb7IOaNG5 .gGeIJ78ljfGpfn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 1.5px;
  height: 10px;
  transform: translate(-50%, -50%);
  border-radius: 1px;
  background-color: var(--ds-text-subtle, #44546f);
}
.CEjhSnb7IOaNG5 .gGeIJ78ljfGpfn::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10px;
  height: 1.5px;
  transform: translate(-50%, -50%);
  background-color: var(--ds-text-subtle, #44546f);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listCardGap": `CEjhSnb7IOaNG5`,
	"disabled": `xrpDw8bh5z3DDg`,
	"hoverBar": `YGGQRDU5eWkKri`,
	"hoverIcon": `gGeIJ78ljfGpfn`
};
export default ___CSS_LOADER_EXPORT___;
